import React from 'react';

import {StdLoading} from './styles';

const LoadingScreen = () => {
  return (
    <>
      <StdLoading id='load'>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path d="M12,5a7,7 0 1,0 0,14a7,7 0 1,0 0,-14" className="inner"></path>
          <path d="M12,5a7,7 0 1,0 0,14a7,7 0 1,0 0,-14" className="outer"></path>
        </svg>
      </StdLoading>
    </>
  );
};
export default LoadingScreen;
